/**
 * Who is holding this admin screen: asked once and kept on the device, so every action carries a
 * name. Only the owner's link asks; a named admin's link brings its own name (decision 38).
 */

import { NAME_MAX, cleanName } from "../../../../shared/admins";

export { NAME_MAX, cleanName };

const KEY = "bd.admin.name";

export function readName(): string | null {
  try {
    return cleanName(localStorage.getItem(KEY) ?? "") || null;
  } catch {
    return null;
  }
}

export function saveName(name: string): void {
  try {
    localStorage.setItem(KEY, name);
  } catch {
    // storage can be unavailable (private mode); the name still holds until the page is closed
  }
}
